export default "__VITE_ASSET__BM3Nl9WY__"